import { object, string } from 'yup';

import 'web-shared/config/yup-config';
import { getFormFieldNameGenerator } from 'web-shared/utils/form';

export interface ForgotPasswordFormValues {
  email: string;
}

export const forgotPasswordFieldNameGenerator = getFormFieldNameGenerator<ForgotPasswordFormValues>();

export const initialValues: ForgotPasswordFormValues = {
  email: '',
};

export const validationSchema = object().typedShape<ForgotPasswordFormValues>({
  email: string().email('emailIsInvalid').required(),
});
